import { FormControl } from '@angular/forms';

export interface ModelAndSerialNumberFieldset {
  modelNumber: FormControl<string | null>;
  serialNumber: FormControl<string | null>;
}
